import { csvEscape, triggerCsvDownload } from './perfHubCsvUtils';
import {
  crmEntryCustomTags,
  crmEntryIntentTags,
  extractCrmCampaignNames,
  formatShortlistIntentLabels,
} from './perfHubShortlistTags';

function buildFilterSlug(campaignFilter, intentFilter) {
  const parts = [];
  if (campaignFilter && campaignFilter !== 'all') {
    parts.push(campaignFilter.replace(/[^\w.-]+/g, '_').slice(0, 24));
  }
  if (intentFilter && intentFilter !== 'all') {
    parts.push(intentFilter.replace(/[^\w.-]+/g, '_'));
  }
  return parts.length ? parts.join('-').toLowerCase() : 'all';
}

export function buildCrmShortlistCsvRows(rows) {
  const headers = [
    'instagram_handle',
    'campaigns',
    'intents',
    'custom_tags',
    'email',
    'notes',
    'updated_at',
    'crm_id',
  ];

  const lines = [headers.map(csvEscape).join(',')];

  for (const c of rows) {
    const campaigns = extractCrmCampaignNames(c);
    const intents = crmEntryIntentTags(c);
    lines.push(
      [
        c.instagram_handle,
        campaigns.join('; '),
        formatShortlistIntentLabels(intents) || '',
        crmEntryCustomTags(c).join('; '),
        c.email,
        c.notes,
        c.updated_at,
        c.id,
      ]
        .map(csvEscape)
        .join(','),
    );
  }

  return lines.join('\n');
}

export function downloadCrmShortlistCsv(rows, { campaignFilter, intentFilter }) {
  if (!rows?.length) return;

  const safeFilter = buildFilterSlug(campaignFilter, intentFilter);
  const csv = buildCrmShortlistCsvRows(rows);
  triggerCsvDownload(`crm-shortlist-${safeFilter}.csv`, csv);
}
